var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"bg-white rounded"},[_c('table',{staticClass:"text-left w-full border-collapse"},[_c('thead',[_vm._t("header")],2),_c('tbody',[_vm._t("body")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }